import { render } from "./App.vue?vue&type=template&id=18c79950&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=18c79950&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=18c79950&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c79950"]])

export default __exports__